import { render, staticRenderFns } from "./serverInfo.vue?vue&type=template&id=915c27da&"
import script from "./serverInfo.vue?vue&type=script&lang=js&"
export * from "./serverInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports